import React, { Component } from "react";
import ReactSVG from "react-svg";
import { buildQueryParams } from "lib/general-helper";

export const TIER_LIST_PAGE_SIZE = 15;
const CHECK_PERIOD = 200;
const MAX_PRELOAD = 20;
const TIER_LIST_SCROLL_PAGE_SIZE = 40;
const TIER_LIST_SCROLL_SCREEN = 400;

class StatTableScrollHandler extends React.Component {
  state = {
    showBackToTop: false,
    maxPageSize: TIER_LIST_PAGE_SIZE,
  };

  constructor(props) {
    super(props);
    this.intervalId = setInterval(this.loadMoreTables, CHECK_PERIOD);
    this.props.setPageSizeOnParent(TIER_LIST_PAGE_SIZE);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    this.intervalId && clearInterval(this.intervalId);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevFilters = buildQueryParams(prevProps.upperFilters);
    const curFilters = buildQueryParams(this.props.upperFilters);
    if (prevFilters !== curFilters) {
      this.setPageSize(TIER_LIST_PAGE_SIZE);
      this.intervalId && clearInterval(this.intervalId);
      this.intervalId = setInterval(this.loadMoreTables, CHECK_PERIOD);
    }
    if (!isNaN(this.props.currentPageSize) && this.props.currentPageSize !== prevProps.currentPageSize) {
      this.setState({ maxPageSize: this.props.currentPageSize });
      this.intervalId && clearInterval(this.intervalId);
      this.intervalId = setInterval(this.loadMoreTables, CHECK_PERIOD);
    }
  }

  loadMoreTables = () => {
    if (this.state.maxPageSize < MAX_PRELOAD) {
      this.setPageSize(this.state.maxPageSize + TIER_LIST_PAGE_SIZE);
    } else {
      clearInterval(this.intervalId);
    }
  };

  setPageSize(page) {
    this.setState({ maxPageSize: page });
    this.props.setPageSizeOnParent(page);
  }

  onScroll = (e) => {
    this.showBackToTop(e);
    this.onLoadScroll(e);
  };

  smoothScroll = (e) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  onLoadScroll = (e) => {
    const { maxPageSize } = this.state;
    const { dataLength } = this.props;
    const table = document.querySelector(`.ReactTable.${this.props.tableName}`);
    const { height, y } = table.getBoundingClientRect();

    if (dataLength <= maxPageSize) {
      return;
    }

    if (height - (window.innerHeight - y) < TIER_LIST_SCROLL_SCREEN) {
      this.setPageSize(this.state.maxPageSize + TIER_LIST_SCROLL_PAGE_SIZE);
    }
  };

  showBackToTop(e) {
    const offset = window.pageYOffset;

    if (!this.state.showBackToTop && offset >= 450) {
      this.setState({ showBackToTop: true });
    } else if (this.state.showBackToTop && offset < 450) {
      this.setState({ showBackToTop: false });
    }
  }

  render() {
    const { showBackToTop } = this.state;
    return (
      <div className={`back-to-top-btn ${showBackToTop ? "" : "_hide"}`} onClick={this.smoothScroll}>
        <ReactSVG wrapperClassName="react-svg" path={"https://static.bigbrain.gg/assets/ugg/icons/back-to-top.svg"} />
      </div>
    );
  }
}

export default StatTableScrollHandler;
